import { Component, OnInit } from '@angular/core';
import { Router,RouterModule} from '@angular/router';

@Component({
  selector: 'app-clientinfo',
  templateUrl: './clientinfo.component.html',
  styleUrls: ['./clientinfo.component.css']
})
export class ClientinfoComponent implements OnInit {
  visible:Boolean = false;

  constructor(public router:Router) { }

  ngOnInit() {
  }
  toggle(){
    this.visible = !this.visible;
  }

}



// WEBPACK FOOTER //
// ./src/app/clientinfo/clientinfo.component.ts